module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, _vm._l((_vm.userRol), function(route) {
    return _c('router-link', {
      key: route.path,
      staticClass: "pageLink",
      attrs: {
        "to": ("" + (route.enlaceWeb)),
        "tag": "li"
      }
    }, [_c('a', [_c('i', {
      class: ("" + (route.icono))
    }), _vm._v(" "), _c('span', {
      staticClass: "page fs-12"
    }, [_vm._v(_vm._s(route.descripcion))])])])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5949570"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 345
// module chunks = 1